import React, { useEffect, useState } from 'react';
import { sess_get, sess_put } from 'utils/HttpRequests';
import moment from 'moment';
import Popup from 'reactjs-popup';
import { toast } from 'react-toastify';
import { AiFillDelete } from 'react-icons/ai';
import PreLoader from 'components/Others/PreLoader';
import Pagination from '../subLevel/Pagination';

const contentStyle = { borderRadius: '16px' };

export function SearchSection(props) {
  const [value, setValue] = useState('');
  const [key, setKey] = useState('');
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const searchHandler = (e) => {
    e.preventDefault();
    props.getInfo({
      value, key, from, to,
    });
  };

  let search = <div />;
  switch (key) {
    case 'created_at':
    case 'initial_activated_at':
    case 'expire_on':
    case 'suspended_at':
      search = (
        <>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label>From</label>
            <input
              type="date"
              style={{ marginRight: '50px' }}
              value={from}
              placeholder="search ..."
              onChange={(e) => setFrom(e.target.value)}
            />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label>To</label>
            <input
              type="date"
              style={{ marginRight: '50px' }}
              value={to}
              placeholder="search ..."
              onChange={(e) => setTo(e.target.value)}
            />
          </div>
        </>
      );
      break;
    case 'status':
      search = (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label>Value</label>
          <select
            style={{ marginRight: '50px', height: '30px' }}
            onChange={(e) => setValue(e.target.value)}
          >
            <option>---select---</option>
            <option value="ACTIVE">ACTIVE</option>
            <option value="DELETED">DELETED</option>
            <option value="FREE_TRIAL">FREE_TRIAL</option>
            <option value="DROPPED_OFF">DROPPED_OFF</option>
            <option value="EXPIRED">EXPIRED</option>
            <option value="SUSPENDED">SUSPENDED</option>
            <option value="TERMINATED">TERMINATED</option>
          </select>
        </div>
      );
      break;
    default:
      search = (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label>Value</label>
          <input
            style={{ marginRight: '50px' }}
            value={value}
            placeholder="search ..."
            onChange={(e) => setValue(e.target.value)}
          />
        </div>
      );
      break;
  }

  return (
    <div style={{
      display: 'flex', justifyContent: 'center', flexDirection: 'row', margin: '60px auto',
    }}
    >
      <form onSubmit={searchHandler} style={{ display: 'flex', alignItems: 'end' }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label>Search By</label>
          <select
            style={{ marginRight: '50px', height: '30px' }}
            onChange={(e) => { setKey(e.target.value); setValue(''); setFrom(''); setTo(); }}
          >
            <option>---select---</option>
            <option value="status">Status</option>
            <option value="user_id">User ID</option>
            <option value="v_mobile_no">Doosra Number</option>
            <option value="zvr_mobile_no">Primary Number</option>
            <option value="created_at">Creation Date</option>
            <option value="initial_activated_at">Activation Date</option>
            <option value="expire_on">Expiry Date</option>
            <option value="suspended_at">Suspension Date</option>
          </select>
        </div>
        {search}
        <button className="btn btn-primary">Search</button>
      </form>
    </div>
  );
}

export function UsersTable(props) {
  const [deleteUser, setDeleteUser] = useState('');
  const displayVMN = (status, number) => {
    if (!status) return '-';
    if (['DELETED', 'BOUNCED'].includes(status)) {
      return '-';
    }
    return number;
  };

  const displayPMN = (status, number) => {
    if (!status) return '-';
    if (['DELETED', 'BOUNCED'].includes(status)) {
      return number;
    }
    return '-';
  };

  return (
    <>
      <DeleteUserPopup deleteUser={deleteUser} userId={deleteUser} closeDeletePopup={() => setDeleteUser('')} fetchData={props.fetchData} />
      <table style={{ tableLayout: 'auto' }}>
        {/* <thead > */}
        <tr>
          <th>Status</th>
          <th>User ID</th>
          <th>VMN</th>
          <th>Primary Number</th>
          <th>Creation Date</th>
          <th>Activation Date</th>
          <th>Expiry Date</th>
          <th>Suspension Date</th>
          <th>Referral Code Used</th>
          <th>Actions</th>
        </tr>
        {/* </thead> */}
        <tbody>

          {props.data.length > 0
            && props.data.map((user) => (
              <tr>
                <td>{user.status || ''}</td>
                <td>{user.user_id || ''}</td>
                <td>{displayVMN(user.status, user.v_mobile_no)}</td>
                <td>{displayPMN(user.status, user.zvr_mobile_no)}</td>
                <td>{user.created_at ? moment(user.created_at).format('DD-MM-YYYY') : ''}</td>
                <td>{user.initial_activated_at ? moment(user.initial_activated_at).format('DD-MM-YYYY') : ''}</td>
                <td>{user.expire_on ? moment(user.expire_on).format('DD-MM-YYYY') : ''}</td>
                <td>{user?.suspend_details?.suspended_at ? moment(user.suspend_details.suspended_at).format('DD-MM-YYYY') : ''}</td>
                <td>{user.refered_by_code || ''}</td>
                <td>
                  {['ACTIVE', 'SUSPENDED', 'EXPIRED'].includes(user.status)
                    && <AiFillDelete onClick={() => setDeleteUser(user.user_id)} style={{ cursor: 'pointer' }} />}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </>
  );
}

export function DeleteUserPopup(props) {
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState('');
  const [confirmationMsg, setConfirmationMsg] = useState('');
  const [reason, setReason] = useState('');

  const deleteUserHandler = () => {
    if (confirmationMsg !== 'DELETE') return setError('invalid confirmation message');
    setProcessing(true);
    const sessionToken = localStorage.getItem('admin-panel-sessionToken');
    sess_put('admin/console/delete-user', sessionToken, { userId: props.userId, reason })
      .then((res) => {
        closeHandler();
        toast.success('user deleted successfully');
        props.fetchData();
      })
      .catch((err) => {
        setProcessing(false);
        setError(err.response.data.error.reason || 'An error occured');
      });
  };

  const closeHandler = () => {
    setError('');
    setReason('');
    setConfirmationMsg('');
    setProcessing(false);
    props.closeDeletePopup();
  };

  return (
    <>
      {processing
        && <PreLoader />}
      <Popup open={props.deleteUser !== ''} closeOnDocumentClick={false} closeOnEscape={false} {...{ contentStyle }}>
        <div style={{ textAlign: 'center', padding: '20px', borderRadius: '16px' }}>

          <h2>Are you sure you want to delete the user?</h2>
          <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'left' }}>
            <label>Reason</label>
            <textarea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              rows={4}
            />
          </div>
          <div style={{
            display: 'flex', flexDirection: 'column', textAlign: 'left', marginTop: '16px',
          }}
          >
            <label>Confirmation message</label>
            <input
              value={confirmationMsg}
              onChange={(e) => setConfirmationMsg(e.target.value)}
              placeholder="DELETE"
            />
          </div>
          {error && <p style={{ color: 'red' }}>{error}</p>}
          <div style={{ display: 'flex', justifyContent: 'space-around', padding: '16px' }}>
            <button className="btn btn-primary" onClick={deleteUserHandler}>Confirm</button>
            <button className="btn btn-primary" onClick={closeHandler}>Cancel</button>
          </div>
        </div>
      </Popup>
    </>
  );
}

export default function UsersKYC() {
  const [data, setData] = useState({});
  const [error, setError] = useState('');
  const [currentPage, SetCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [value, setValue] = useState('');
  const [key, setKey] = useState('');
  const [fromDate, setFrom] = useState('');
  const [toDate, setTo] = useState('');
  const pageSize = 10;

  useEffect(() => {
    fetchData(currentPage, pageSize);
  }, []);

  const fetchData = (pageNo, pageSize, search_text, search_category, from, to) => {
    const searchData = {};
    if (pageNo) searchData.pageNo = pageNo;
    searchData.pageSize = (pageSize) || 10;
    if (search_text) {
      searchData.search_text = search_text;
      setValue(search_text);
    } else if (value !== '') searchData.search_text = value;
    if (search_category) {
      searchData.search_category = search_category;
      setKey(search_category);
    } else if (key !== '') searchData.search_category = key;
    if (from) {
      searchData.from = from;
      setFrom(from);
    } else if (from !== '') searchData.form = fromDate;
    if (to) {
      searchData.to = to;
      setTo(to);
    } else if (to !== '') searchData.to = toDate;
    console.log(searchData);
    const session_token = localStorage.getItem('admin-panel-sessionToken');
    sess_get('admin/console/ivr/profile', session_token, searchData)
      .then((res) => {
        setData(res?.data?.response?.profiles);
        setLastPage(res?.data?.response?.totalPages);
        SetCurrentPage(res?.data?.response?.pageNo);
      })
      .catch((err) => { setError(err?.response?.data?.error?.reason || 'something went wrong'); });
  };

  return (
    <div style={{}}>
      <SearchSection getInfo={(data) => { fetchData(1, 10, data.value, data.key, data.from, data.to); }} />
      <UsersTable data={data} fetchData={fetchData} />
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        margin: '30px',
      }}
      >
        <Pagination
          getInfo={(data) => { fetchData(data.pageNo); }}
          currentPage={currentPage}
          lastPage={lastPage}
        />
      </div>

    </div>
  );
}
